export const MCD_NO_MALLS_NEAR_ANALYZED_LOCATION_MODAL = 'mcdNoMallsNearAnalyzedLocationModal'
